/*
 * @Author: your name
 * @Date: 2021-11-15 10:20:56
 * @LastEditTime: 2021-11-25 13:59:09
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\ticket\incomeTicket\incomeTicket.routing.ts
 */
export const IncomeTicketRouting = [
  {
    path: "/ticket/incomeTicket/list",
    name: "income-ticket-list",
    meta: { title: "收票管理" },
    component: () => import("@/views/ticket/incomeTicket/list/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/incomeTicket/create",
    name: "income-ticket-create",
    meta: { title: "新增收票登记",comName:"ticketIncomeTicketFormCreate" },
    component: () => import("@/views/ticket/incomeTicket/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/incomeTicket/edit/:id",
    name: "income-ticket-edit",
    meta: { title: "编辑收票记录",comName:"ticketIncomeTicketFormCreate" },
    component: () => import("@/views/ticket/incomeTicket/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/incomeTicket/detail/:id",
    name: "income-ticket-index",
    meta: { title: "收票登记详情" },
    component: () => import("@/views/ticket/incomeTicket/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/incomeTicket/flowPrint/:id",
    name: "income-ticket-flow-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/ticket/incomeTicket/flow-print/index.vue"),
  },
];
